module.exports = __webpack_public_path__ + "static/media/zamygo_partner_kaces.b4648604.png";